export const AUTHENTICATION_EVENT = 'socialAuthenticationMessage';
export const WINDOW_NAME = 'SocialAuthenticationFlowWindow';
